import { render } from "./manager.vue?vue&type=template&id=72655cdd&scoped=true"
import script from "./manager.vue?vue&type=script&lang=js"
export * from "./manager.vue?vue&type=script&lang=js"

import "./manager.vue?vue&type=style&index=0&id=72655cdd&lang=less&scoped=true"

import exportComponent from "/Users/cain/Workspaces/projects/roar/roar-fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.30_vue@3.5.30_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72655cdd"]])

export default __exports__